import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/Httpconfig";
import Constant from "../../constants";
import { Multiselect } from "multiselect-react-dropdown";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DiagnosisHeader from "../diagnostics/DiagnosisHeader";
import DiagnosisMenu from "../diagnostics/DiagnosisMenu";
import Footer from "../patient/Patientfooter";
import * as SecureLS from "secure-ls";
import constants from "../../constants";

var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

const moment = require("moment");

export default class DiagnosticsCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      category_image: null,
      status: 1,
      testsSearch: "",
      testsResults: [],
      selectedTestIds: [],
      selectedTests: [],
      diagnosisId: "",
      selectedProducts: [], // For Multiselect component
      isSubmitting: false, // Add loading state
      isSearching: false, // Add search loading state
      lastSearchText: "", // Track last search text to prevent duplicate searches
      searchInputFocused: false, // Track if search input is focused
    };

    // Initialize search timeout reference
    this.searchTimeout = null;
  }

  // To get details after first render
  componentDidMount = () => {
    const { handle } = this.props.match.params;
    let userData = ls.get("diagnosisObj");

    if (userData) {
      if (userData != "") {
        this.setState({
          diagnosisId: userData.diagnosis_id,
        });

        // Fetch all available tests for the retailer
        this.fetchAllTests(userData.diagnosis_id);

        this.forceUpdate();
      }
    }
    // Removed redirect - allow viewing without login

    if (handle) this.getCategoryInfo(handle);
  };

  // Clean up timeouts when component unmounts
  componentWillUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  // Get category info for editing
  getCategoryInfo(category_id) {
    console.log("Fetching category info for ID:", category_id);

    const payload = {
      test_type_id: parseInt(category_id),
    };

    const url = constants.siteurl + "api/DIAGNOSTIC/test-type/details";
    console.log("🔍 Calling URL:", url);
    console.log("📤 With payload:", payload);

    Httpconfig.httptokenpost(url, payload)
      .then((response) => {
        console.log("✅ Category details response:", response.data);

        if (
          response.data &&
          response.data.error === false &&
          response.data.data
        ) {
          const categoryData = response.data.data.category;
          const assignedTests = response.data.data.assigned_tests || [];

          console.log("📋 Category Data:", categoryData);
          console.log("🧪 Assigned Tests:", assignedTests);

          // Build selectedProducts array for Multiselect from assigned_tests
          let selectedProducts = [];
          let selectedTestIds = [];

          if (assignedTests.length > 0) {
            // Get unique medicine IDs
            const medicineIds = [
              ...new Set(assignedTests.map((test) => test.medicine_id)),
            ];
            console.log("💊 Medicine IDs:", medicineIds);

            // Fetch test details for these medicine IDs
            this.fetchTestNamesByIds(medicineIds).then((testsWithNames) => {
              console.log("✅ Fetched test names:", testsWithNames);

              this.setState({
                fields: {
                  category_name: categoryData.name,
                },
                status: categoryData.status === "active" ? 1 : 0,
                selectedProducts: testsWithNames,
                selectedTestIds: testsWithNames.map((t) => parseInt(t.id)),
              });

              console.log("✅ Pre-filled state updated");
            });
          } else {
            // No assigned tests, just set category info
            this.setState({
              fields: {
                category_name: categoryData.name,
              },
              status: categoryData.status === "active" ? 1 : 0,
              selectedProducts: [],
              selectedTestIds: [],
            });

            console.log("✅ Category info loaded (no assigned tests)");
          }
        } else {
          console.error("❌ Invalid response structure:", response.data);
          toast.error("Failed to load category details");
        }
      })
      .catch((error) => {
        console.error("❌ Error fetching category details:", error);
        console.error("Response:", error.response?.data);
        console.error("Status:", error.response?.status);

        // Fallback: Try to get basic info from list
        console.log("⚠️ Falling back to category list...");
        this.getCategoryInfoFallback(category_id);
      });
  }

  // Fallback method to get basic category info from list when details API fails
  getCategoryInfoFallback(category_id) {
    Httpconfig.httptokenget(constants.siteurl + "api/DIAGNOSTIC/testcategories")
      .then((response) => {
        if (
          response.data &&
          response.data.error === false &&
          response.data.data
        ) {
          const categories = response.data.data;
          const category = categories.find((cat) => cat.id == category_id);

          if (category) {
            this.setState({
              fields: {
                category_name: category.name,
              },
              status: category.status === "active" ? 1 : 0,
              selectedProducts: [],
              selectedTestIds: [],
            });

            toast.info(
              "Loaded basic info. Assigned tests are preserved on update."
            );
          } else {
            toast.error("Category not found");
          }
        }
      })
      .catch((error) => {
        console.error("Error in fallback:", error);
        toast.error("Failed to load category data");
      });
  }

  // Helper method to fetch test names by IDs
  fetchTestNamesByIds(medicineIds) {
    if (medicineIds.length === 0) return Promise.resolve([]);

    console.log("🔍 Fetching test names for medicine IDs:", medicineIds);

    // Make individual API calls for each medicine_id to get accurate test details
    const fetchPromises = medicineIds.map((medicine_id) => {
      return Httpconfig.httptokenget(
        constants.siteurl +
          "api/DIAGNOSIS/diagnosisProduct/medicine/" +
          medicine_id
      )
        .then((response) => {
          if (
            response.data &&
            Array.isArray(response.data.data) &&
            response.data.data.length > 0
          ) {
            // Find the exact test with matching ID
            const foundTest = response.data.data.find(
              (t) => t.id == medicine_id
            );
            if (foundTest) {
              console.log(
                `✅ Found test for ID ${medicine_id}:`,
                foundTest.testname
              );
              return {
                id: foundTest.id,
                test_name: foundTest.testname,
                displayLabel: `${foundTest.testname} - MRP: ₹${foundTest.mrp}`,
                mrp: foundTest.mrp,
                discount: foundTest.discount,
                description: foundTest.description,
              };
            }
          }
          // If not found, return placeholder
          console.warn(`⚠️ Test not found for medicine_id: ${medicine_id}`);
          return {
            id: medicine_id,
            test_name: `Test ID: ${medicine_id}`,
            displayLabel: `Test ID: ${medicine_id}`,
          };
        })
        .catch((error) => {
          console.error(`❌ Error fetching test ${medicine_id}:`, error);
          return {
            id: medicine_id,
            test_name: `Test ID: ${medicine_id}`,
            displayLabel: `Test ID: ${medicine_id}`,
          };
        });
    });

    // Wait for all fetch promises to complete
    return Promise.all(fetchPromises).then((results) => {
      const validResults = results.filter(Boolean);
      console.log("✅ All test names fetched:", validResults);
      return validResults;
    });
  }

  handleImageUpload = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({ category_image: reader.result });
    };
    reader.readAsDataURL(file);
  };

  handleDeleteImage = () => {
    this.setState({ category_image: null });
  };

  handleChange = (field, e) => {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({ fields });
  };

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    // Validate category_name (mandatory)
    if (!fields["category_name"]) {
      formIsValid = false;
      errors["category_name"] = "Category name cannot be empty";
    } else if (!/^[@ _ a-zA-Z0-9- ]*$/.exec(fields["category_name"])) {
      formIsValid = false;
      errors["category_name"] = "Category name contains invalid characters";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  checkSubmit(event) {
    event.preventDefault();
    const { handle } = this.props.match.params;

    if (this.handleValidation() && handle) {
      this.updateCategory(event);
    } else if (this.handleValidation() && handle == undefined) {
      this.createCategory(event);
    } else {
      toast.warn("Form has errors.");
    }
  }

  // Create new category
  createCategory = (event) => {
    event.preventDefault();

    // Prevent double submission
    if (this.state.isSubmitting) {
      return;
    }

    const { fields, status, selectedTestIds } = this.state;

    console.log("Creating category with selectedTestIds:", selectedTestIds);
    console.log("Selected products:", this.state.selectedProducts);

    const payload = {
      name: fields.category_name,
      status: status ? "active" : "inactive",
      medicine_ids:
        selectedTestIds && selectedTestIds.length > 0 ? selectedTestIds : [],
    };

    console.log("Create category payload:", payload);

    // Set loading state
    this.setState({ isSubmitting: true });

    Httpconfig.httptokenpost(
      constants.siteurl + "api/DIAGNOSTIC/test-type",
      payload
    )
      .then((response) => {
        console.log("Create category response:", response);
        console.log("response.data:", response.data);
        console.log(
          "response.data.status:",
          response.data.status,
          "type:",
          typeof response.data.status
        );
        console.log(
          "response.data.error:",
          response.data.error,
          "type:",
          typeof response.data.error
        );

        if (
          response.data &&
          (response.data.status === 201 || response.data.status === "201") &&
          response.data.error === false
        ) {
          console.log(response.data);
          const newCategoryId = response.data.data.id;
          toast.success(`Category created successfully`);
          setTimeout(
            () =>
              this.props.history.push({
                pathname: "/diagnostics/ViewDiagnosticsCategories",
                state: { highlightId: newCategoryId },
              }),
            1500
          );
        } else {
          console.log("Falling into unexpected response case");
          this.setState({ isSubmitting: false });
          toast.error("Unexpected response from server");
        }
      })
      .catch((error) => {
        console.error("Error creating category:", error);
        this.setState({ isSubmitting: false });
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Error creating category";
        toast.error(errorMessage);
      });
  };

  // Update category
  updateCategory = (event) => {
    event.preventDefault();

    // Prevent double submission
    if (this.state.isSubmitting) {
      return;
    }

    const { handle } = this.props.match.params;
    const { selectedTestIds } = this.state;

    console.log("Updating category with selectedTestIds:", selectedTestIds);
    console.log("Selected products:", this.state.selectedProducts);

    const payload = {
      category_id: parseInt(handle),
      medicine_ids:
        selectedTestIds && selectedTestIds.length > 0 ? selectedTestIds : [],
      status: this.state.status ? "active" : "inactive",
    };

    console.log("Update category payload:", payload);

    // Set loading state
    this.setState({ isSubmitting: true });

    Httpconfig.httptokenput(
      constants.siteurl + "api/DIAGNOSTIC/test-type/update",
      payload
    )
      .then((response) => {
        console.log("Update category response:", response);
        if (
          response.data &&
          response.data.status === 200 &&
          response.data.error === false
        ) {
          toast.success("Category updated successfully");
          setTimeout(
            () =>
              this.props.history.push("/diagnostics/ViewDiagnosticsCategories"),
            1500
          );
        } else if (response.data && response.data.error === true) {
          this.setState({ isSubmitting: false });
          toast.error(response.data.message || "Failed to update category");
        } else {
          this.setState({ isSubmitting: false });
          toast.error("Unexpected response from server");
        }
      })
      .catch((error) => {
        console.error("Error updating category:", error);
        this.setState({ isSubmitting: false });
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Error updating category";
        toast.error(errorMessage);
      });
  };

  // Fetch all tests using search endpoint
  fetchAllTests = (retailerId) => {
    console.log("🔍 Fetching all tests for retailer:", retailerId);

    Httpconfig.httptokenpost(
      constants.siteurl + "api/DIAGNOSIS/diagnosisProduct/search",
      {
        retailerId: 1,
        search_type: "medicine_search",
        testname: "",
      }
    )
      .then((response) => {
        console.log("✅ All tests response:", response.data);

        if (
          response.data &&
          response.data.error === false &&
          response.data.data
        ) {
          const allTests = response.data.data.map((item) => ({
            id: item.id,
            test_name: item.testname,
            test_description: item.description,
            price:
              item.diagnosis_product_tbls &&
              item.diagnosis_product_tbls.length > 0
                ? item.diagnosis_product_tbls[0].mrp
                : null,
            discount:
              item.diagnosis_product_tbls &&
              item.diagnosis_product_tbls.length > 0
                ? item.diagnosis_product_tbls[0].discount
                : null,
            displayLabel:
              item.testname +
              (item.diagnosis_product_tbls &&
              item.diagnosis_product_tbls.length > 0 &&
              item.diagnosis_product_tbls[0].mrp
                ? ` - ₹${item.diagnosis_product_tbls[0].mrp}`
                : ""),
          }));

          console.log(`✅ Loaded ${allTests.length} tests`);
          this.setState({ testsResults: allTests });
        }
      })
      .catch((error) => {
        console.error("❌ Error fetching all tests:", error);
      });
  };

  // Debounced search to prevent too many API calls
  searchTests = (searchText) => {
    // Clear any existing timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Set a new timeout for debounced search
    this.searchTimeout = setTimeout(() => {
      this.performSearch(searchText);
    }, 500); // Increased delay to 500ms for better UX
  };

  performSearch = (searchText) => {
    const { diagnosisId, lastSearchText } = this.state;

    // Prevent duplicate searches
    if (searchText === lastSearchText) {
      return;
    }

    // If no search text, don't immediately clear results to prevent input clearing
    if (!searchText || searchText.trim() === "") {
      this.setState({
        lastSearchText: searchText,
        isSearching: false,
      });
      // Only fetch all tests if we previously had no results
      if (this.state.testsResults.length === 0 && diagnosisId) {
        this.fetchAllTests(diagnosisId);
      }
      return;
    }

    // Set loading state and update last search text
    this.setState({
      isSearching: true,
      lastSearchText: searchText,
    });

    // Use search endpoint like diagnostics tests page
    Httpconfig.httptokenpost(
      constants.siteurl + "api/DIAGNOSIS/diagnosisProduct/search",
      {
        retailerId: 1,
        search_type: "medicine_search",
        testname: searchText,
      }
    )
      .then((response) => {
        if (
          response.data &&
          response.data.error === false &&
          response.data.data
        ) {
          const allTests = response.data.data.map((item) => ({
            id: item.id,
            test_name: item.testname,
            test_description: item.description,
            price:
              item.diagnosis_product_tbls &&
              item.diagnosis_product_tbls.length > 0
                ? item.diagnosis_product_tbls[0].mrp
                : null,
            discount:
              item.diagnosis_product_tbls &&
              item.diagnosis_product_tbls.length > 0
                ? item.diagnosis_product_tbls[0].discount
                : null,
            displayLabel:
              item.testname +
              (item.diagnosis_product_tbls &&
              item.diagnosis_product_tbls.length > 0 &&
              item.diagnosis_product_tbls[0].mrp
                ? ` - ₹${item.diagnosis_product_tbls[0].mrp}`
                : ""),
          }));

          console.log(
            `🔍 Search "${searchText}" found ${allTests.length} tests`
          );
          this.setState({
            testsResults: allTests,
            isSearching: false,
          });
        } else {
          console.log(`🔍 Search "${searchText}" found no results`);
          this.setState({
            testsResults: [],
            isSearching: false,
          });
        }
      })
      .catch((error) => {
        console.error("Error searching tests:", error);
        this.setState({
          testsResults: [],
          isSearching: false,
        });
      });
  };

  render() {
    const {
      fields,
      errors,
      category_image,
      status,
      testsResults,
      selectedTests,
    } = this.state;
    const { handle } = this.props.match.params;

    return (
      <main id="main">
        <DiagnosisHeader />
        <DiagnosisMenu />
        <section
          id="main_dashboard"
          className="col-md-offset-2"
          style={{ marginLeft: "180px" }}
        >
          <div className="container-fluid" id="main_front">
            <div className="row">
              <div className="col-md-10">
                <div className="dash-section">
                  <div className="section-header">
                    <ol className="breadcrumb">
                      <li className="active">
                        <Link to="/diagnosis"> Dashboard</Link> &gt;
                        <Link to="/diagnostics/ViewDiagnosticsCategories">
                          {" "}
                          Categories
                        </Link>{" "}
                        &gt;
                        <a> {handle ? "Edit" : "Create"} Category </a>
                      </li>
                    </ol>
                  </div>
                </div>

                <section id="CMS_tab">
                  <div className="CMS_content create_calender">
                    <div className="container">
                      <div className="row">
                        <div className="tab-header">
                          <h3>
                            {handle
                              ? "Update Category Management"
                              : "Create Category Management"}
                          </h3>
                        </div>
                        <div id="reg_form">
                          <form onSubmit={this.checkSubmit.bind(this)}>
                            <div className="row align-items-start">
                              <div className="col-md-4">
                                <div
                                  className="form-group"
                                  style={{ marginTop: 0 }}
                                >
                                  <label
                                    style={{
                                      display: "block",
                                      marginBottom: 8,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Category Name
                                  </label>
                                  <input
                                    type="text"
                                    name="category_name"
                                    value={fields["category_name"] || ""}
                                    onChange={(e) =>
                                      this.setState({
                                        fields: {
                                          ...this.state.fields,
                                          category_name: e.target.value,
                                        },
                                      })
                                    }
                                    className="form-control"
                                    placeholder="Category Name"
                                  />
                                  <span className="cRed">
                                    {errors["category_name"]}
                                  </span>
                                </div>
                                <div className="form-group">
                                  <label>Status</label>
                                  <select
                                    value={status ? "active" : "inactive"}
                                    onChange={(e) =>
                                      this.setState({
                                        status:
                                          e.target.value === "active" ? 1 : 0,
                                      })
                                    }
                                    className="form-control"
                                  >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                  </select>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div
                                  className="form-group"
                                  style={{ marginTop: 0 }}
                                >
                                  <label
                                    htmlFor="products"
                                    className="custom-control-label"
                                    style={{
                                      display: "block",
                                      marginBottom: 8,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Products
                                  </label>
                                  <div style={{ width: "100%" }}>
                                    <Multiselect
                                      options={this.state.testsResults}
                                      displayValue="displayLabel"
                                      selectedValues={
                                        this.state.selectedProducts
                                      }
                                      onSelect={(
                                        selectedList,
                                        selectedItem
                                      ) => {
                                        const testIds = selectedList.map(
                                          (test) => parseInt(test.id)
                                        );
                                        this.setState((prevState) => ({
                                          selectedProducts: [...selectedList],
                                          selectedTestIds: testIds,
                                          selectedTests: [...selectedList],
                                        }));
                                      }}
                                      onRemove={(selectedList, removedItem) => {
                                        const testIds = selectedList.map(
                                          (test) => parseInt(test.id)
                                        );
                                        this.setState((prevState) => ({
                                          selectedProducts: [...selectedList],
                                          selectedTestIds: testIds,
                                          selectedTests: [...selectedList],
                                        }));
                                      }}
                                      onSearch={(searchText) => {
                                        this.searchTests(searchText);
                                      }}
                                      onFocus={() => {
                                        this.setState({
                                          searchInputFocused: true,
                                        });
                                      }}
                                      onBlur={() => {
                                        this.setState({
                                          searchInputFocused: false,
                                        });
                                      }}
                                      placeholder={
                                        this.state.isSearching
                                          ? "Searching..."
                                          : "Search & Select Products"
                                      }
                                      showCheckbox={true}
                                      closeOnSelect={false}
                                      singleSelect={false}
                                      selectionLimit={-1}
                                      caseSensitiveSearch={false}
                                      emptyRecordMsg={
                                        this.state.isSearching
                                          ? "Searching..."
                                          : "No products found. Start typing to search..."
                                      }
                                      keepSearchTerm={true}
                                      hidePlaceholderWhenOptionsFound={false}
                                      style={{
                                        chips: {
                                          background: "#007bff",
                                          color: "#fff",
                                          fontWeight: "bold",
                                        },
                                        multiselectContainer: {
                                          color: "#333",
                                          width: "100%",
                                        },
                                        searchBox: {
                                          cursor: "text",
                                          width: "100%",
                                        },
                                        optionContainer: { cursor: "pointer" },
                                        option: { cursor: "pointer" },
                                      }}
                                    />
                                  </div>

                                  <div
                                    style={{
                                      marginTop: "8px",
                                      minHeight: "24px",
                                    }}
                                  >
                                    {this.state.selectedProducts &&
                                      this.state.selectedProducts.length > 0 &&
                                      this.state.selectedProducts.map(
                                        (test) => (
                                          <span
                                            key={test.id}
                                            style={{
                                              display: "inline-block",
                                              background: "#007bff",
                                              color: "#fff",
                                              borderRadius: "12px",
                                              padding: "4px 12px",
                                              marginRight: "6px",
                                              marginBottom: "4px",
                                              fontSize: "13px",
                                            }}
                                          >
                                            {test.test_name}
                                          </span>
                                        )
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="form-group col-md-12">
                                <button
                                  type="submit"
                                  className="btn  btn-primary save_btn"
                                  disabled={this.state.isSubmitting}
                                >
                                  {this.state.isSubmitting
                                    ? "Saving..."
                                    : "Save Category"}
                                </button>{" "}
                                &nbsp;
                                <Link
                                  to="/diagnostics/ViewDiagnosticsCategories"
                                  className="cancel_btn"
                                >
                                  Cancel
                                </Link>{" "}
                                &nbsp; &nbsp;
                              </div>
                            </div>
                          </form>
                        </div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <Footer />
        <ToastContainer />
      </main>
    );
  }
}
